// extracted by mini-css-extract-plugin
export default {"navStyle":"LayoutNavigation_navStyle__LCXmm","borderBottomNone":"LayoutNavigation_borderBottomNone__+M+Ch"};